import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/true-size-of-islands/page.tsx");
